import auth from '@/apps/auth/api';
import kiosk from '@/apps/kiosk/api';
import desktop from '@/apps/desktop/api';
import menu from '@/apps/menu/api';
import cart from '@/apps/cart/api';

export default {
  auth,
  kiosk,
  desktop,
  menu,
  cart,
};



// WEBPACK FOOTER //
// ./src/api/index.js